<template>
  <div class="about">
    <div class="md-layout md-alignment-center">
      <div :key="index" class="commentHolder">
        <md-field>
          <label>Mail</label>
          <md-input v-model="mail"></md-input>
        </md-field>
        <md-field>
          <label>Password</label>
          <md-input v-model="pwd"></md-input>
        </md-field>
        <md-button class="md-raised md-primary" @click="onLogin()">Ajouter commentaire</md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// @ is an alias to /src

export default {
  name: "me",
  components: {},
  computed: {
    ...mapGetters(["getMyDataContent"])
  },
  methods: {
    ...mapActions(["login"]),
    async onLogin() {
      await this.login({ mail: this.mail, pwd: this.pwd });
      this.$router.push("/dashboard");
    }
  }
};
</script>

<style >
</style>
